import { UseFormSetValue, UseFormWatch } from "react-hook-form";

import { ERROR_TYPE, translateError } from "@/utils";

import CompanyRevenueSelectorItem from "./CompanyRevenueSelectorItem";

interface CompanyRevenueSelectorFactoryProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	watch: UseFormWatch<any>;
	companyRevenues: { id: number; value: string }[];
	error?: string;
	containerClassName?: string;
}

export default function CompanyRevenueSelectorFactory({
	setValue,
	watch,
	companyRevenues,
	error,
	containerClassName = "",
}: CompanyRevenueSelectorFactoryProps) {
	const selectedCompanyRevenues = watch("companyRevenueIds");

	return (
		<div className={`space-y-1 mb-4 w-full relative ${containerClassName}`}>
			<CompanyRevenueSelectorItem
				companyRevenues={companyRevenues}
				error={error}
				fieldName="companyRevenueIds"
				setValue={setValue}
				value={selectedCompanyRevenues}
			/>
			{error && (
				<p className="absolute -bottom-5 text-[12px] text-[#FF1034]">
					{translateError[error as ERROR_TYPE] ?? error}
				</p>
			)}
		</div>
	);
}
